function getUrlVars() {
	const vars = {};
	window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
		(m, key, value) => {
			vars[key] = value;
		});
	return vars;
}

export default getUrlVars;
